import { useState } from 'react'

import { LegacyPage, Stack, Button } from 'peach/components'

const ScratchError = () => {
  const [renderError, setRenderError] = useState(false)

  const throwFromClick = () => {
    throw new Error('Thrown from a click Handler')
  }

  if (renderError) {
    throw new Error('Thrown from render ')
  }

  return (
    <LegacyPage>
      <Stack>
        <Button onClick={throwFromClick}>Throw from a click handler</Button>
        <Button onClick={() => setRenderError(true)}>Throw from render</Button>
      </Stack>
    </LegacyPage>
  )
}

export default ScratchError
